import createNotification from './createNotification';
import utility from './utility';

const accountDocuments = {
    fileSelector1: null,
    fileSelector2: null,
    fileSelector2enabled: false,

    init: function () {
        // configure file selector
        const div = document.createElement('div');
        if (!((('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window)) {
            return;
        }

        // show pending approval popup
        const pendingDocumentsButton = document.querySelector("#account--upload-documents-pending");
        if (pendingDocumentsButton) {
            pendingDocumentsButton.onclick = () => this.showPendingApprovalPopup();
        }

        // show upload popup
        const uploadDocumentsButton = document.querySelector("#account--upload-documents-edit");
        if (uploadDocumentsButton) {
            uploadDocumentsButton.onclick = () => this.showUploadDocumentsPopup();
        }

        // file selectors
        const fileSelectors = document.querySelectorAll("#account--upload-documents-form .file-upload");
        if (fileSelectors.length !== 2) {
            return;
        }
        this.fileSelector1 = new fileSelector(fileSelectors[0], this.showMoreButton);
        this.fileSelector2 = new fileSelector(fileSelectors[1], null);
        this.fileSelector2.hide();
        this.fileSelector2enabled = false;

        // upload documents submit
        const uploadDocumentsForm = document.querySelector("#account--upload-documents-form");
        if (uploadDocumentsForm) {
            uploadDocumentsForm.onsubmit = () => {
                this.uploadDocument();
                return false;
            };
        }
        // more button
        const moreButton = document.getElementById("account--upload-documents-more");
        if (moreButton) {
            moreButton.style.display = "none";
            moreButton.onclick = () => {
                document.getElementById("account--upload-documents-more").style.display = "none";
                accountDocuments.fileSelector2enabled = true;
                accountDocuments.fileSelector2.show();
            };
        }

        // error message
        const inputError = document.querySelector("#account--upload-documents-form .input-error");
        if (inputError) {
            inputError.style.display = "none";
        }
    },

    showPendingApprovalPopup: function () {
        utility.showPopup(document.querySelector("#account--pending-documents-popup"));
    },

    showMoreButton: function () {
        if (!accountDocuments.fileSelector2enabled) {
            document.getElementById("account--upload-documents-more").style.display = "";
        }
    },

    uploadDocument: function () {
        const formData = new FormData();
        const fileSelects = document.querySelectorAll("#account--upload-documents-form input[type='file']");
        if (fileSelects) {
            for (let i = 0; i < fileSelects.length; i++) {
                const fileSelect = fileSelects[i];
                if (fileSelect && fileSelect.files.length > 0) {
                    formData.append("document", fileSelect.files[0], fileSelect.files[0].name);
                }
            }
        }
        const ajaxOptions = {
            url: "/api/web/account/upload-files",
            method: "POST",
            data: formData,
            contentType: null,
            success: function (e) {
                const result = JSON.parse(e.target.responseText);
                const errorElement = document.querySelector("#account--upload-documents-form .input-error");
                if (result.success) {
                    utility.hidePopups();
                    createNotification(result.message);
                    errorElement.style.display = "none";
                    setTimeout(() => {
                        window.location.href = "/account/";
                    }, 2000)
                }
                else {
                    errorElement.textContent = result.message;
                    errorElement.style.display = null;
                }
            },
            always: function () {
                utility.enableButton(document.querySelector("#account--upload-documents-form button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#account--upload-documents-form button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    }
};

class fileSelector {
    constructor(inputUpload, fileSelectedEvent) {
        this.inputUpload = inputUpload;
        this.fileSelectedEvent = fileSelectedEvent;
        this.typesContainer = inputUpload.querySelector('.file-upload-types');
        this.maxContainer = inputUpload.querySelector('.file-upload-max');
        this.fileInput = inputUpload.querySelector('input[type="file"]');
        this.uploadImage = inputUpload.querySelector('.upload-image');
        this.initialImage = this.uploadImage.src;
        this.droppedFiles = false;
        this.ValidImageTypes = ["image/gif", "image/jpeg", "image/png", "image/gif", "image/tif"];
        this.readURL();
        this.fileInput.onchange = () => {
            this.fireChange();
        }
    }

    fireChange() {
        this.clearError();
        if (this.fileInput.files && this.fileInput.files[0]) {
            if (this.fileInput.files[0]['size'] <= 5000000) {
                this.maxContainer.classList.remove('error');
            }
            else {
                this.maxContainer.classList.add('error');
                this.showFileSizeError();
                return;
            }
            if (this.ValidImageTypes.indexOf(this.fileInput.files[0]['type']) >= 0) {
                this.typesContainer.classList.remove('error');
                this.readURL();
                if (this.fileSelectedEvent) {
                    this.fileSelectedEvent();
                }
            }
            else {
                this.typesContainer.classList.add('error');
                this.resetFile();
                this.showFileTypeError();
            }
        }
        else {
            this.resetFile();
        }
    }

    show() {
        this.inputUpload.style.display = "";
        this.inputUpload.click();
    }

    hide() {
        this.inputUpload.style.display = "none";
    }

    resetFile() {
        this.uploadImage.src = this.initialImage;
        this.fileInput.value = '';
    }

    readURL(input) {
        var reader = new FileReader();
        reader.addEventListener('load', e => {
            this.uploadImage.src = e.target.result;
        });
        if (this.fileInput.files && this.fileInput.files[0]) {
            if (this.fileInput.files[0]['type'] && this.ValidImageTypes.indexOf(this.fileInput.files[0]['type']) >= 0) {
                reader.readAsDataURL(this.fileInput.files[0]);
            }
            else if (this.initialImage) {
                this.uploadImage.src = this.initialImage;
            }
        }
    }

    showFileSizeError() {
        const errorElement = document.querySelector("#account--upload-documents-form .input-error");
        errorElement.textContent = "Document exceeds the maximum upload size 5MB. Please save it as a smaller size and try again.";
        errorElement.style.display = null;
    }

    showFileTypeError() {
        const errorElement = document.querySelector("#account--upload-documents-form .input-error");
        errorElement.textContent = "Invalid document type. File type must be a JPG, PNG, TIF or GIF.";
        errorElement.style.display = null;
    }

    clearError() {
        const errorElement = document.querySelector("#account--upload-documents-form .input-error");
        errorElement.style.display = "none";
    }
}

export default accountDocuments;


// WEBPACK FOOTER //
// ./assets/src/js/classes/accountDocuments.js